var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v(_vm._s(_vm.osName))]),_c('br'),_c('img',{staticStyle:{"height":"600px"},attrs:{"src":_vm.image,"alt":_vm.osName},on:{"click":function($event){return _vm.expandImage(_vm.image)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }